import React, { useState, useEffect, forwardRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import {
  Add as AddIcon,
  Edit as EditIcon
} from '@mui/icons-material'

import {
  Button,
  Grid,
  Table,
  TableBody,
  TableHead,
  Card,
  Divider,
  Typography,
  Snackbar,
  IconButton,
  Alert as MuiAlert,
  CardContent,
  TableContainer
} from '@mui/material'

import ModulesDrawer from '../application/application/modulesDialog'
import { SnackBarHideDuration, SnackBarTransition, StyledTableCell, StyledTableRow } from '../../utils/ui_utils'
import { businessCheck } from '../../utils/utils'
import { useModuleCreate, useModuleFetch, useModuleUpdate } from '../../modules/modules/modulesHooks'

function Modules() {
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(100)
  const { moduleFetchLoading, moduleFetchData, moduleFetchError, moduleFetch } = useModuleFetch();
  const { moduleCreate, moduleCreateData, moduleCreateError, moduleCreateLoading } = useModuleCreate();
  const { moduleUpdate, moduleUpdateData, moduleUpdateError, moduleUpdateLoading } = useModuleUpdate();
  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const [moduleDrawerMode, setModuelDrawerMode] = useState('edit')
  const [moduleInitalValues, setModuleInitialValues] = useState({})
  const [moduleDrawerVisible, setModuleDrawerVisible] = useState(false)
  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const history = useNavigate()

  useEffect(() => {
    businessCheck(history)
    let payLoad = {
      pageNumber: page,
      limit: limit
    }
    moduleFetch(payLoad)
  }, [])


  if (moduleFetchError) return <p>Error!</p>
  if (moduleFetchLoading) return <p>Loading...</p>
  return (
    <>
      <Helmet title="Modules" />
      <Grid container sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Grid item xs={5} md={6}>
          <Typography variant="h4" gutterBottom display="inline">
            Modules
          </Typography>
        </Grid>
        <Grid item>
          <Button startIcon={<AddIcon />}
            variant="contained"
            size="small"
            color="primary" onClick={() => {
              setModuleDrawerVisible(true)
              setModuleInitialValues({ module_name: '' })
              setModuelDrawerMode('new')
            }}>
            Add Modules
          </Button>
          <ModulesDrawer
            initialValues={moduleInitalValues}
            title={moduleDrawerMode == 'new' ? "Create New Module" : "Edit Module"}
            visible={moduleDrawerVisible}
            onSubmit={async (values) => {
              if (moduleDrawerMode == 'new') {
                await moduleCreate(values)
                if (moduleCreateError) {
                  setModuleDrawerVisible(true)
                  toastMessage("Error occurred", "error")
                } else if (moduleCreateData) {
                  setModuleDrawerVisible(false)
                  toastMessage("Module created successfully", "success")
                  let payLoad = {
                    pageNumber: page,
                    limit: limit
                  }
                  moduleFetch(payLoad)
                }
              }
              else {
                values.id = values._id
                delete values._id
                delete values.key
                await moduleUpdate(values)
                if (moduleUpdateError) {
                  setModuleDrawerVisible(true)
                  toastMessage("Error occurred", "error")
                } else if (moduleUpdateData) {
                  setModuleDrawerVisible(false)
                  toastMessage("Module updated successfully", "success")
                  let payLoad = {
                    pageNumber: page,
                    limit: limit
                  }
                  moduleFetch(payLoad)
                }
              }
            }}
            onClose={() => {
              setModuleDrawerVisible(false)
            }}
            okText={moduleDrawerMode == 'new' ? "Create" : "Update"}
          />
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: 5 }} />
      <Grid container spacing={10} sx={{ paddingTop: 5 }}>
        <Grid item xs={5} md={3} >
          <Card raised sx={{ borderRadius: 3 }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <TableContainer component={Card}>
                <Table size="small">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Modules Name</StyledTableCell>
                      <StyledTableCell align='right'>Edit</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {moduleFetchData.map((row, i) => (
                      <StyledTableRow key={i} hover onClick={() => setModuleInitialValues(row)}>
                        <StyledTableCell>
                          {row.module_name}
                        </StyledTableCell>
                        <StyledTableCell align='right'>
                          <IconButton
                            size="small"
                            color="primary"
                            component="span"
                            onClick={() => {
                              setModuleDrawerVisible(true)
                              setModuelDrawerMode("edit")
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  )
}
export default Modules
